import { render, staticRenderFns } from "./ResetPassMain.vue?vue&type=template&id=3d9381af&"
import script from "./ResetPassMain.vue?vue&type=script&lang=js&"
export * from "./ResetPassMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d9381af')) {
      api.createRecord('3d9381af', component.options)
    } else {
      api.reload('3d9381af', component.options)
    }
    module.hot.accept("./ResetPassMain.vue?vue&type=template&id=3d9381af&", function () {
      api.rerender('3d9381af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user_login/ResetPassMain.vue"
export default component.exports